
/* -----------------------------------------------------------------------------------------------------
  - Created: [20-02-2025] by [SREERAJ]
  - Modified: [YYYY-MM-DD] 
  - Description: This file contains EquipmentReportTable using MUI components
  ------------------------------------------------------------------------------------------------------- */

import React, { useEffect, useState } from 'react';
import CustomBottomPagination from '../../../../Components/custom_components/CustomBottomPagination/CustomBottomPagination';
import EquipmentReportFilter from '../EquipmentReportFilter/EquipmentReportFilter';
import Loader from '../../../../Components/Loader/Loader';
import CustomTable from '../../../../Components/custom_components/CustomTable/CustomTable';
import { handlePaginationEntries } from '../../../../utils/pagination';
import { get_equipment_reports_with_pagination } from '../../../../config/ReportApis/equipmentReportApis';
import useDataExport from '../../../../utils/useDataExport';

function EquipmentReportTable() {

    const [equipmentReport, setEmployeeReport] = useState([]);

    // Calculate the total pages based on the number of items and items per page
    const [pageNumber, setPageNumber] = useState(1);
    const [totalItemPerPage, setTotalItemPerPage] = useState(25);
    const [totalPages, setTotalPages] = useState(0);
    const [pagination, setPagination] = useState({ start: 0, end: 0, totalEntries: 0 });

    const [filterValues, setFilterValues] = useState({}); // Define filter values state
    const [isLoading, setIsLoading] = useState(false); // Loader state


    // Columns for the table
    const columns = [
        { title: "#", key: "key" },
        { title: "Equipment Name", key: "EquipmentName" },
        { title: "WorkSite", key: "WorkSite" },
        { title: "Schedule Code", key: "ScheduleCode" },
        { title: "Mandays ", key: "Mandays" },
        { title: "Start Date", key: "Start_Date" },
        { title: "End Date ", key: "End_Date" },

    ] 


    // Map the schedule data into table rows
    const rows = () => equipmentReport?.map((item, index) => ({
        key: pageNumber * totalItemPerPage - (totalItemPerPage - (index + 1)),
        EquipmentName: item.EquipmentName,
        WorkSite: item.WorksiteName,
        ScheduleCode: item?.Schedule_Code,
        Mandays: item.Days,
        Start_Date: item.StartDate,
        End_Date: item?.EndDate,
    }));


    const headers = columns.map(col => col.title);

    const mapDataFn = (item, index) => [
        index + 1,
        item?.EquipmentName || "—",
        item?.WorksiteName || "—",
        item?.Schedule_Code || "—",
        item?.Days || 0,
        item?.StartDate || "—",
        item?.EndDate || "—",
    ];
    const {
        handleExportExcel,
        handleExportPDF,
        isExportingExcel,
        isExportingPDF,
    } = useDataExport(
        get_equipment_reports_with_pagination,
        mapDataFn,
        headers,
        "Equipment Report"
    );
    // Fetch schedule data on page change or refresh
    useEffect(() => {
        getEmployeeReport();
    }, [pageNumber, totalItemPerPage, filterValues]);


    // Fetch schedule data from API
    const getEmployeeReport = async () => {
        const formData = new FormData();
        formData.append('page', pageNumber);
        formData.append('pageItemcount', totalItemPerPage);

        // Append filter values to formData
        Object.keys(filterValues).forEach(key => formData.append(key, filterValues[key]));

        try {
            setIsLoading(true)
            const response = await get_equipment_reports_with_pagination(formData);
            if (response?.status === "success") {
                const data = response?.data;
                setEmployeeReport(data?.data);
                setTotalPages(data.last_page);
                setPagination(handlePaginationEntries(data.from, data.to, data.total));
            } else {
                setEmployeeReport([]);
            }
        } catch (error) {

        } finally {
            setIsLoading(false)
        }
    };

    // Handle search filter change
    const handleSearchFilter = (filterValues) => {
        setFilterValues(filterValues);
    };

    // Handle pagination changes
    const handlePageChange = (pageNumber) => setPageNumber(pageNumber);
    const handleItemPageCountChange = (pageItemCount) => setTotalItemPerPage(pageItemCount);


    return (
        <div className='report-table-container'>
            <EquipmentReportFilter
                tableTitle="Equipment Report"
                searchFilter={handleSearchFilter}

                on_change_value={handlePageChange}
                on_page_count_update={handleItemPageCountChange}

                onExportPDF={() => handleExportPDF(filterValues, { page: 1, pageItemCount: pagination?.totalEntries })}
                onExportExcel={() => handleExportExcel(filterValues, { page: 1, pageItemCount: pagination?.totalEntries })}
                isExportingPDF={isExportingPDF}
                isExportingExcel={isExportingExcel}

            />
            <div className="table-container">
                <CustomTable
                    columns={columns}
                    rows={isLoading ? [] : rows()}
                    isLoading={isLoading}
                />
            </div>
            <div className='pagination-container'>
                {isLoading ? <Loader /> : <CustomBottomPagination
                    items_per_page={totalItemPerPage}
                    current_page={pageNumber}
                    total_page_count={totalPages}
                    on_change_value={handlePageChange}
                    on_page_count_update={handleItemPageCountChange}
                    pagination={pagination}
                />}
            </div>
        </div>
    );
}

export default EquipmentReportTable;
